

(function($, window, document) {
    // The $ is now locally scoped 

    


    function is_ie() {

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
        {
            return true;
        }
        else  // If another browser, return 0
        {
            return false;
        }

        return false;
    }


    function is_mozilla() {

        if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
            return true;
        }

        return false;
    }



    //  COOKIES

    function createCookie(name, value, days) {
        if(days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          var expires = "; expires=" + date.toGMTString();
        } else var expires = "";
        document.cookie = name + "=" + value + expires + "; path=/"
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
         
        }
        return null;
    }

    function eraseCookie(name) {
        createCookie(name, "", -1);
    }


    

    var target_search = window.location.search;

    target_search = target_search.replace('?', '');


    
    


    var targets_search = target_search.split("&");
    // console.log(targets_search);
    for(var i = 0; i < targets_search.length; i++){
        if(targets_search[i].split("=")[0] == "section"){
        

        }
    }

    var target_hash = window.location.hash;
    target_hash = target_hash.replace('#', '');
    // delete hash so the page won't scroll to it
    window.location.hash = "";

    if(target_hash){
        window.history.replaceState({}, document.title, window.location.href.replace("#",""));
    }


    // now whenever you are ready do whatever you want
    // (in this case I use jQuery to scroll to the tag after the page has loaded)
    
    if (target_hash) {
        setTimeout(function(){
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#" + target_hash).offset().top - $('.lp-header-section').innerHeight()
            }, 1000);

        },1000);
    }


    





    $(window).scroll(function(event) {
        var scrollTop = $(window).scrollTop();
        var winHeight = $(window).innerHeight();

        // $('.lp-header-section .lp-header-top .lp-header-top-container').css('margin-top', '-'+scrollTop+'px');

        // if(scrollTop > $('.lp-header-section .lp-header-top').innerHeight() && scrollTop > 5){
        //     $('body').addClass('no-top');
        // }else{
        //     $('body').removeClass('no-top');
        //     // setTimeout(function(){
        //     //     $('body').css({ 'padding-top': $('.lp-header-section').innerHeight()+'px' });
        //     // },200);
        // }

        // if(scrollTop > (winHeight / 4)){
        //     $('body').addClass('scrolled');
        // }else{
        //     $('body').removeClass('scrolled');
        // }

        // if(scrollTop > $('.lp-header-section .lp-header-top').innerHeight()){
        //     $('body').addClass('fix-header');
        // }else{
        //     $('body').removeClass('fix-header');
        // }

        
        // if(scrollTop > winHeight ){
        //     $('.lp-back-to-top').addClass('active');
        // }else{
        //     $('.lp-back-to-top').removeClass('active');
        // }


    });


    $('.lp-back-to-top').click(function(event) {
        $("html, body").animate({ scrollTop: "0" },1000);
    });


    $('a[href^="#"]').on('click', function(e) {
        e.preventDefault();
        var id = $(this).attr('href'),
                targetOffset = $(id).offset().top;
                
        $('html, body').animate({ 
            scrollTop: targetOffset - $('.lp-header-section').innerHeight()
        }, 1000);
    });



    $('.lp-header-menu-button').click(function(event) {
        if($(this).hasClass('active')){
            $(this).removeClass('active');
            $('.lp-header-menu-close').removeClass('active');
            $('.lp-header-nav').removeClass('active');
            $(this).find('svg').removeClass('active');
            $('body').removeClass('menu-open');
        }else{

            $(this).addClass('active');
            $('.lp-header-menu-close').addClass('active');
            $('.lp-header-nav').addClass('active');
            $('.lp-header-menu-button svg').addClass('active');
            $('body').addClass('menu-open');
        }
    });



    $('.lp-header-menu-close, .lp-header-menu li a').click(function(event) {
        $('.lp-header-menu-close').removeClass('active');
        $('.lp-header-menu-button').removeClass('active');
        $('.lp-header-nav').removeClass('active');
        $('.lp-header-menu-button svg').removeClass('active');
        $('body').removeClass('menu-open');
    });



    window.addEventListener('resize', function(event){
        // $('body').css({ 'padding-top': $('.lp-header-section').innerHeight()+'px' });
        // setTimeout(function(){
        //     $('body').css({ 'padding-top': $('.lp-header-section').innerHeight()+'px' });
        // },1000);

        if($(window).innerWidth() > 767){

            $('.lp-header-menu-close').removeClass('active');
            $('.lp-header-menu-button').removeClass('active');
            $('.lp-header-menu').removeClass('active');
            $('.lp-header-menu-button svg').removeClass('active');
            $('body').removeClass('menu-open');
        }
        
    });
    // $('body').css({ 'padding-top': $('.lp-header-section').innerHeight()+'px' });
    // setTimeout(function(){
    //     $('body').css({ 'padding-top': $('.lp-header-section').innerHeight()+'px' });
    // },500);
    // setTimeout(function(){
    //     $('body').css({ 'padding-top': $('.lp-header-section').innerHeight()+'px' });
    // },1000);
    // setTimeout(function(){
    //     $('body').css({ 'padding-top': $('.lp-header-section').innerHeight()+'px' });
    // },2000);

	





	//Function  Mask
    function mask(o, f) {
        setTimeout(function () {
            var v = f(o.value);
            if (v != o.value) {
                o.value = v;
            }
        }, 1);
    }

    function mphone(v) {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
        v = v.replace(/(\d)(\d{4})$/, "$1-$2");
        return v;
    }

    function mcep(v) {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d{5})(\d{3})?/, "$1-$2");
        return v;
    }

    function mnum(v) {
        v = v.replace(/\D/g, "");
        return v;
    }

    function memail(v) {
        v = v.replace(/[()+=#%!{}\[\];:,<>?/\|""''&*°\\/´`~^$¨]/g, "");
        var parts = v.split('@');
        v = "";
        for(var i = 0; i < parts.length; i++){
            if(i == 1){
                v += "@";
            }
            v += parts[i];
        }
        
        return v;
    }


    function mCNPJ(v) {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1.$2.$3/$4-$5");
        while(v[v.length - 1] == '-' || v[v.length - 1] == '/' || v[v.length - 1] == '.'){
            v = v.substring(0, v.length - 1);
        }
        return v;
    }

    function mCPF(v) {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d{3})(\d{3})?(\d{3})?(\d{2})?/, "$1.$2.$3-$4");
        while(v[v.length - 1] == '-' || v[v.length - 1] == '/' || v[v.length - 1] == '.'){
            v = v.substring(0, v.length - 1);
        }
        return v;
    }

    function mtext(v) {
        v = v.replace(/[0123456789()_+-=#@%!{}\[\];:,<>?/\|""''&*°\\/´`~^$¨]/g, "");
        return v;
    }

    $('input[type="tel"],.mask-tel').keypress(function() {
        mask(this, mphone);
    });

    $('input[type="email"],.mask-email').keypress(function() {
        mask(this, memail);
    });


    $('input.mask-cep').keypress(function() {
        mask(this, mcep);
    });

    $('input.mask-num').keypress(function() {
        mask(this, mnum);
    });

    $('input.mask-cpf').keypress(function() {
        mask(this, mCPF);
    });

    $('input.mask-cnpj').keypress(function() {
        mask(this, mCNPJ);
    });

    $('input.mask-text').keypress(function() {
        mask(this, mtext);
    });

    $('input[type="tel"],.mask-tel').change(function() {
        mask(this, mphone);
    });

    $('input[type="email"],.mask-email').change(function() {
        mask(this, memail);
    });


    $('input.mask-cep').change(function() {
        mask(this, mcep);
    });

    $('input.mask-num').change(function() {
        mask(this, mnum);
    });

    $('input.mask-text').change(function() {
        mask(this, mtext);
    });

    $('input.mask-cpf').change(function() {
        mask(this, mCPF);
    });

    $('input.mask-cnpj').change(function() {
        mask(this, mCNPJ);
    });



    $('input[type="tel"],.mask-tel').keyup(function() {
        mask(this, mphone);
    });

    $('input[type="email"],.mask-email').keyup(function() {
        mask(this, memail);
    });


    $('input.mask-cep').keyup(function() {
        mask(this, mcep);
    });

    $('input.mask-num').keyup(function() {
        mask(this, mnum);
    });

    $('input.mask-text').keyup(function() {
        mask(this, mtext);
    });

    $('input.mask-cpf').keyup(function() {
        mask(this, mCPF);
    });

    $('input.mask-cnpj').keyup(function() {
        mask(this, mCNPJ);
    });




    $(".mask-cpf-cnpj").keydown(function(event){
        if(event.keyCode == 8){

            var v = this.value.trim();
            v = v.replace(/\./g, '');
            v = v.replace('-', '');
            v = v.replace('/', ''); 
            v = v.replace('.', ''); 

            if(v.length < 13){

                mask(this, mCPF);
            }else{

                mask(this, mCNPJ);
            }
        }

    });


    $(".mask-cpf-cnpj").keypress(function(){

        var v = this.value.trim();
        v = v.replace(/\./g, '');
        v = v.replace('-', '');
        v = v.replace('/', ''); 
        v = v.replace('.', ''); 

        if(v.length < 11){

            mask(this, mCPF);
        }else{

            mask(this, mCNPJ);
        }

    });


    $(".mask-cpf-cnpj").change(function(event ){


        var v = this.value.trim();
        v = v.replace(/\./g, '');
        v = v.replace('-', '');
        v = v.replace('/', ''); 
        v = v.replace('.', ''); 


        if(v.length < 12){

            mask(this, mCPF);
        }else{

            mask(this, mCNPJ);
        }
        

    });


    $(".mask-cpf-cnpj").each(function(index, el){
        var v = this.value.trim();
        v = v.replace(/\./g, '');
        v = v.replace('-', '');
        v = v.replace('/', ''); 
        v = v.split('');

        if(v.length < 12){

            mask(el, mCPF);
        }else{

            mask(el, mCNPJ);
        }
    });


    $('input.mask-cpf').each(function(index, el){
        mask(el, mCPF);
    });
    $('input.mask-cnpj').each(function(index, el){
        mask(el, mCNPJ);
        
    });
    $('input[type="tel"],.mask-tel').each(function(index, el) {
        mask(el, mphone);
    });
    $('input.mask-cep').each(function(index, el) {
        mask(el, mcep);
    });
    





    $("form:not(.no-validate) select").each(function(index, el) {
        var option = $(this).find('option')[0];
        if(option.value == ''){
            $(option).attr({
                disabled: 'true',
                selectec: 'true'
            });
        } 

        $(this).change(function(event) {
            $(this).addClass('changed');
        });
    });


    $("form:not(.no-validate)").submit(function(event) {

        if($(this).hasClass('wpcf7-form')){

            $(this).find('input[type=submit]').attr({ disabled: '' });
            $(this).addClass('loading');
        }

        var inputs = $(this).find('input:not(.no-validate,[type="submit"])');
        var textareas = $(this).find('textarea:not(.no-validate)');
        var selects = $(this).find('select:not(.no-validate)');

        var error = false;

        inputs.each(function(index, el) {
            if(el.value == "" || el.value == null ){
                $(el).addClass('lp-form-error');
                error = true
            }
        });

        textareas.each(function(index, el) {
            if(el.value == "" || el.value == null ){
                $(el).addClass('lp-form-error');
                error = true
            }
        });

        selects.each(function(index, el) {
            if(el.value == "" || el.value == null || el.value == "Assunto" || el.value == "Cidade" ){
                $(el).addClass('lp-form-error');
                error = true
            }
        });




        if(error){
            event.preventDefault();
        }
    });




    // Set recaptcha token to input
    if(typeof grecaptcha !== 'undefined') {
        grecaptcha.ready(function() {
            grecaptcha.execute('6LevP_ghAAAAAMYVFekdXR5uvbDf_enjroR-SGu9', {action: 'submit'}).then(function(token) {
                var i = $('input.g-recaptcha-t');
    
                if(i.val() == '') i.val(token);
            });
        });
    }

    $("form").each(function(event) {
        var inputs = $(this).find('input');
        var textareas = $(this).find('textarea');
        var selects = $(this).find('select');

        

        inputs.each(function(index, el) {
            $(el).change(function(event) {
                if(el.value != "" && el.value != null ){
                    $(el).removeClass('lp-form-error');
                    $(el).parent().find('.wpcf7-not-valid-tip').remove();
                    // console.log($(el).parent().find('.wpcf7-not-valid-tip'));
                }
            });
            
        });

        textareas.each(function(index, el) {
            $(el).change(function(event) {
                if(el.value != "" && el.value != null ){
                    $(el).removeClass('lp-form-error');
                    $(el).parent().find('.wpcf7-not-valid-tip').remove();
                }
            });
        });

        selects.each(function(index, el) {
            $(el).change(function(event) {
                if(el.value != "" && el.value != null && el.value != "UF" && el.value != "Cidade" ){
                    $(el).removeClass('lp-form-error');
                    $(el).parents('.select-container').find('.wpcf7-not-valid-tip').remove();
                }
            });
        });


    });


	var stado_cidade = null;

    $(".lp-contact-filed-address").each(function(index, el) {

        var input_estado = $(el).find('.lp-contact-form-select-state');
        var input_cidade = $(el).find('.lp-contact-form-select-city');

        input_estado.empty()
        input_estado.append(new Option("UF", '', true, true));
        input_estado.find('option').prop("disabled", true);


        input_cidade.empty()
        input_cidade.append(new Option("Cidade", '', true, true));
        input_cidade.find('option').prop("disabled", true);




        if(stado_cidade == null && $(this).data("caminho") != undefined && $(this).data("caminho") != '' && $(this).data("caminho") != null){
            $.getJSON($(this).data("caminho"), function(jd) {
                var estados = jd.estados;
                
                var estado = null;

                for(i = 0; i < estados.length; i++){
                    estado = estados[i];
                    if(typeof input_estado.data('selected') === 'undefined'){
                        input_estado.data('selected','');
                    }
                    input_estado.append(new Option(estado.sigla, estado.sigla,(input_estado.data('selected').trim() == estado.sigla.trim()),(input_estado.data('selected').trim() == estado.sigla.trim())));
                    estado = null;
                }

                input_estado.change(function(event) {
                    for(i = 0; i < estados.length; i++){
                        if(estados[i].sigla == this.value){
                            cidades = estados[i].cidades;

                            input_cidade.empty()
                            input_cidade.append(new Option("Cidade", '', true, true));
                            input_cidade.find('option').prop("disabled", true);
                            if(typeof input_cidade.data('selected') === 'undefined'){
                                input_cidade.data('selected','');
                            }
                            
                            for(o = 0; o < cidades.length; o++){
                                input_cidade.append(new Option(cidades[o], cidades[o],(input_cidade.data('selected').trim() == cidades[o].trim()),(input_cidade.data('selected').trim() == cidades[o].trim())));
                                
                            }

                        }
                    }
                });

                

                if(input_estado.data('selected') != ""){
                    setTimeout(function(){
                        input_estado.change();

                    },10);
                }
            });

        }
    });



    // if($('.lp-gallery-section .gallery-list').length > 0){
    //     $('.lp-gallery-section .gallery-list').lightGallery({
    //         selector: '.gallery-item',
    //         download: false,
    //         addClass: 'lg-gallery-item',
    //         // thumbnail: false,
    //     });
    // }


    // if($('.lp-products-section .lp-products-list').length > 0){
    //     $('.lp-products-section .lp-products-list').lightGallery({
    //         selector: '.product-img-link',
    //         download: false,
    //         addClass: 'lg-gallery-item',
    //         // thumbnail: false,
    //     });
    // }

    
}(window.jQuery, window, document));

